import BaseComponent from '../../base_component/base_component'

export default class Tabs extends BaseComponent {
    initialize() {
        $(this.component).find('[data-toggle="tab"]').on('shown.bs.tab', function() {
            let $target = $($(this).attr('href'));
            let newUrl = window.location.href.replace(
                /(#.*)?$/, '#' + $(this).attr('data-name'));
            window.history.pushState({urlPath: newUrl}, {}, newUrl);
            let tables = $target.find('.dataTables_scrollBody table');
            if (tables && tables.DataTable) {
                tables.DataTable().draw();
            }
        });
        if (window.location.href.includes('#')) {
            let tabName = window.location.href.split('#')[1];
            this.loadTab(tabName);
        }
    }

    functions() {
        return {loadTab: tabName => this.loadTab(tabName)}
    }

    loadTab(tabName) {
        let tab = this.find(`[data-name="${tabName}"`);
        if (tab.length) {
            tab.first().click();
        }
    }
}